interface HistoryControlsProps {
  canUndo: boolean;
  canRedo: boolean;
  onUndo: () => void;
  onRedo: () => void;
}

export function HistoryControls({ canUndo, canRedo, onUndo, onRedo }: HistoryControlsProps) {
  return (
    <div className="history-controls" role="group" aria-label="Project history">
      <button
        className="studio-action-button"
        disabled={!canUndo}
        onClick={onUndo}
        type="button"
        aria-label="Undo last action"
      >
        <span aria-hidden="true">↶</span>
        Undo
      </button>
      <button
        className="studio-action-button"
        disabled={!canRedo}
        onClick={onRedo}
        type="button"
        aria-label="Redo last action"
      >
        <span aria-hidden="true">↷</span>
        Redo
      </button>
    </div>
  );
}
